import React from "react";
import { Container, Box, Typography, List, ListItem, ListItemIcon, ListItemText, Divider, Button, Grid, Chip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const ETicaretSatisMuhasebesi = () => {
  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Box textAlign="center" mb={4}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          E‑Ticaret Satış Muhasebesi
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Trendyol, Hepsiburada, N11, Çiçeksepeti, Amazon TR ve Shopify, ikas gibi kanallarda satış yapan işletmeler için
          uçtan uca satış muhasebesi, e‑belge ve raporlama çözümleri sunuyoruz.
        </Typography>
      </Box>

      <Grid container spacing={2} justifyContent="center" mb={3}>
        {[
          "Trendyol", "Hepsiburada", "N11", "Amazon TR", "PttAVM", "Shopify", "ikas", "İdeasoft"
        ].map((tag) => (
          <Grid item key={tag}>
            <Chip label={tag} size="small" color="primary" variant="outlined" />
          </Grid>
        ))}
      </Grid>

      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Neden E‑Ticaret Muhasebe Çözümümüz?
      </Typography>
      <List>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="Pazaryeri komisyon, hizmet bedeli ve kargo masraflarının doğru muhasebeleştirilmesi" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="E‑Fatura, e‑Arşiv ve e‑İrsaliye süreçlerinin uçtan uca yönetimi" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="İade/iptal işlemleri, kupon/indirim ve satış teşviklerinin KDV etkilerinin takibi" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="Pazaryeri ödeme dekontları ile muhasebe kayıtlarının mutabakatı" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="Stok, varyant ve çoklu depo hareketlerinin raporlanması" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="Aylık KDV, Muhtasar, BA/BS ve e‑defter süreçlerinde tam uyum" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
      </List>

      <Divider sx={{ my: 3 }} />

      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Sunduğumuz Hizmetler
      </Typography>
      <List>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="Pazaryeri Entegrasyonlarının Kurulumu (XML/CSV API, e‑belge entegrasyonu)" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="Satış, komisyon, hizmet bedeli ve kargo giderlerinin tekilleştirilmiş muhasebe kaydı" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="İade/iptal, mahsup ve komisyon iadelerinin otomatik eşleştirilmesi" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="Çok kanallı satışlarda KDV oran yönetimi (temel gıda, kitap, elektronik vb.)" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="Pazaryeri ödeme planı, dekont ve faturalarıyla dönemsel mutabakat raporları" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="Aylık yönetim raporları: kârlılık, kanal bazlı satış ve komisyon analizi" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
      </List>

      <Divider sx={{ my: 3 }} />

      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Nasıl Çalışıyoruz?
      </Typography>
      <List>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="İhtiyaç Analizi: Satış kanalları, kategori ve hacim bazlı durum tespiti" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="Kurulum & Entegrasyon: e‑Belge ve muhasebe akışlarının devreye alınması" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="Aylık Operasyon: Kayıtların oluşturulması, kontroller ve mutabakat" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon><CheckIcon color="success" /></ListItemIcon>
          <ListItemText primary="Raporlama & Danışmanlık: Kârlılık analizi, vergi planlaması ve büyüme önerileri" primaryTypographyProps={{ fontWeight: 'medium', variant: 'body2' }} />
        </ListItem>
      </List>

      <Box textAlign="center" mt={4}>
        <Typography variant="body1" gutterBottom>
          E‑ticaret operasyonunuz için doğru muhasebe altyapısını birlikte kuralım. Hızlı teklif almak için bize ulaşın.
        </Typography>
        <Button variant="contained" color="primary" href="/iletisim" style={{ textTransform: 'none' }}>
          Hemen İletişime Geçin
        </Button>
      </Box>
    </Container>
  );
};

export default ETicaretSatisMuhasebesi;
